/**
 * Raccourcis clavier des QCM : les touches 1 à 4 activent la proposition de même
 * rang. Sur 193 questions, viser quatre boutons à la souris est le vrai frein de
 * vitesse, et le clavier était déjà à moitié supporté (les boutons sont
 * focusables et leur `:focus-visible` est stylé) : il ne manquait que l'accès
 * direct.
 *
 * La position physique de la touche (`event.code`) prime sur le caractère
 * produit : sur un clavier AZERTY, la rangée du haut donne « & é " ' » sans
 * Shift, et un joueur qui appuie sur la touche « 1 » attend la première réponse,
 * pas un caractère.
 */

/** Rang (0–3) de la proposition visée par la touche, ou null. */
function answerIndex(event) {
    const fromCode = /^(?:Digit|Numpad)([1-4])$/.exec(event.code || "");
    if (fromCode) return Number(fromCode[1]) - 1;
    // Repli pour les dispositions ou navigateurs sans `code` exploitable.
    if (/^[1-4]$/.test(event.key)) return Number(event.key) - 1;
    return null;
}

/** Une saisie en cours a la priorité : le mode hard tape le nom du pays. */
function isTyping() {
    const el = document.activeElement;
    if (!el) return false;
    return el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable === true;
}

/**
 * @param {HTMLElement} container conteneur des boutons `.country`
 * @returns {Function} désinscription
 */
export function bindAnswerKeys(container) {
    if (!container) return () => {};

    const onKeyDown = (event) => {
        if (event.metaKey || event.ctrlKey || event.altKey || event.repeat) return;
        if (isTyping()) return;

        const index = answerIndex(event);
        if (index === null) return;

        // Les boutons sont relus à chaque frappe : ils sont recréés à chaque tour.
        const button = container.querySelectorAll(".country")[index];
        if (!button) return;

        event.preventDefault();
        button.click();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
}
